// const hideShowSoliShadeWallContainer = (color) => {
//   if(color === 'Chili Red'){
//     $('.add-essentials_block[data-product-handle="soli-shade-wall"]').hide();
//     return;
//   }

//   $('.add-essentials_block[data-product-handle="soli-shade-wall"]').show();
// }

$(document).ready(function () {
//   $(".block-header").on("click", function () {
//     $(this).find("+ .block-options").toggleClass("active");

//     const productSoliShadeWall = $('.add-essentials_block[data-product-handle="soli-shade-wall"]');

//     if (productSoliShadeWall) {
//       productSoliShadeWall
//         .find(".block-option-item")
//         .hide();

//       const colorVariantSelected = $('#container-form-product .pg__option[data-option-name="color"] .pg__option__value.selected').data("value");
//       productSoliShadeWall
//         .find(`.block-option-item[data-variant-title*="${colorVariantSelected}"]`)
//         .show();
//     }
//   });
  
//   $(document).on("click","[data-option-name='color'] .pg__option__value",function (e, fromMainSlider) {
//       e.preventDefault();
//       if ($(this).hasClass("selected")) {
//         return;
//       }

//       $(".add-essentials-wrapper .image-essentials").addClass("hidden");
//       const colorProductSelected = $(this).attr("title");
//       $(`.add-essentials-wrapper .image-essentials[alt="${colorProductSelected}"]`).removeClass("hidden");
//   });

//   $(document).on("click","[data-option-name='color'] .pg__option__value",function (e, fromMainSlider) {
//       e.preventDefault();
//       $(document)
//         .find(".add-essentials_block .block-options")
//         .removeClass("active");

//       const color = $(this).data('value')
//       // hideShowSoliShadeWallContainer(color);
    
//   });

//   const colorProductSelected = $("[data-option-name='color'] .pg__option__value.selected").attr("title");
//   // hideShowSoliShadeWallContainer(colorProductSelected);
//   $(`.add-essentials-wrapper .image-essentials[alt="${colorProductSelected}"]`).removeClass("hidden");

//   const sizeValue = $("[data-option-name='size'] .pg__option__value.selected").data("value");
//   $(".add-essentials-wrapper .block-option-item").addClass("hide");
//   $(".add-essentials-wrapper .block-option-item").each(function () {
//     if ($(this).attr("data-variant-title").includes(sizeValue)) {
//       $(this).removeClass("hide");
//     }
//   });

//   $("[data-option-name='size'] .pg__option__value").on("click", function () {
//     const nsizeValue = $(this).data("value");
//     $(".add-essentials-wrapper .block-option-item").addClass("hide");
//     $(".add-essentials-wrapper .block-option-item").each(function () {
//       if ($(this).attr("data-variant-title").includes(nsizeValue)) {
//         $(this).removeClass("hide");
//       }
//     });
//     const firstVisibleItem = $(".add-essentials-wrapper .block-option-item")
//       .not(".hide")
//       .first();
//     if (firstVisibleItem.length) {
//       const dataVariantPrice = firstVisibleItem.attr("data-variant-price");
//        $('.block-header .price').text(`$${dataVariantPrice}`);
//     }
//   });
  
  
  
  
  
//   // add-bundle-wrapper
  
  $('.add-bundle-wrapper .selected_variant').on("click", function () {
    $(this).siblings('.block-options').slideToggle();
  });
  $('.add-bundle-wrapper .option-item-label').on("click", function () {
    var txt = $(this).find('.title').text();
    var img = $(this).find('img').attr('src');
    $(this).parents('.block-options').siblings('.selected_variant').find('.title').text(txt);
    $(this).parents('.block-options').siblings('.selected_variant').find('img').attr('src',img);
  });
});

